<template>
  <div v-if="errorCode != ''">
    <HR />
    <h2 v-if="errorMessages.length === 0">This request completed with errors({{errorCode}})</h2>
    <h2 v-for="(message, i) in errorMessages" v-bind:key="'message_' + i">{{message}}</h2>
    Click here to begin again:
    <a href="#" class="" v-on:click="reselect" v-on:keyup.enter="reselect" v-on:keyup.space="reselect" v-focus="">Back to {{selectionTitle}} selection</a>
  </div>
</template>
<script>

  /* eslint no-unused-vars: 'off' */

  export default {
    /*model: {
      isEnabled: 'true'
    },*/
    props: ['errorCode', 'errorMessages', 'selectionPath', 'selectionTitle'],
    created: function () {
    },
    data: function () {
      var vm = this;
      return {
      }
    },
    methods: {
      reselect: function (event) {
        this.$router.push({ path: this.selectionPath })
      }
    }
  }
</script>

<style scoped>
</style>
